import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useResources } from "../hooks/queries/useResources";

const BRANCHES = [
    "Computer Science",
    "Information Technology",
    "Electronics and Telecommunication",
    "Mechanical",
    "Civil",
];

const useResourcesFacade = () => {
    const navigate = useNavigate();
    const { data: resData, isLoading: loading } = useResources();
    const [selectedBranch, setSelectedBranch] = useState("");

    const filteredResources = useMemo(() => {
        return resData?.filter((resource) => {
            if (selectedBranch && resource.branch !== selectedBranch) return false;
            return true;
        });
    }, [resData, selectedBranch]);

    return {
        loading,
        filteredResources,
        selectedBranch,
        setSelectedBranch,
        branches: BRANCHES,
        navigate,
    };
};

export default useResourcesFacade;
